export default __webpack_public_path__ + "static/media/minivistaw-mejoraelrendimiento.a6d8a4ab.jpg";